import { useCallback, useMemo, useState } from 'react';
import { platformOrder } from '../../platformMeta';
import { SocialPlatform } from '../../types';

/**
 * The "Post on" chips of a plan: every usable channel is on until the user toggles a chip. A
 * channel that is no longer usable drops out of the pick.
 */
export function usePlanChannelPick(usable: SocialPlatform[]): {
  selected: SocialPlatform[];
  toggle: (platform: SocialPlatform) => void;
} {
  // Null until the user toggles a chip: every usable channel is on.
  const [picked, setPicked] = useState<SocialPlatform[] | null>(null);
  const selected = useMemo(() => (picked ?? usable).filter((platform) => usable.includes(platform)), [picked, usable]);
  const toggle = useCallback(
    (platform: SocialPlatform) =>
      setPicked((current) => {
        const base = current ?? usable;
        const next = base.includes(platform) ? base.filter((one) => one !== platform) : [...base, platform];
        return platformOrder.filter((one) => next.includes(one));
      }),
    [usable]
  );
  return { selected, toggle };
}
